import { Link } from "react-router-dom";

const COLS = [
  {
    title: "Comprendre",
    links: [
      { to: "/definition-sculpteur-contemporain", label: "Qu'est-ce qu'un sculpteur contemporain ?" },
      { to: "/courants-et-mouvements", label: "Courants & mouvements" },
      { to: "/materiaux-et-techniques", label: "Matériaux & techniques" },
    ],
  },
  {
    title: "Ressources",
    links: [
      { to: "/lexique-sculpture", label: "Lexique de la sculpture" },
      { to: "/guide-achat-direct-artiste", label: "Acheter en direct d'un atelier" },
      { to: "/faq", label: "Questions fréquentes" },
      { to: "/#sommaire", label: "Sommaire du guide" },
      { to: "/contact", label: "Contact éditorial" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-ink/10 bg-ink text-paper">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 py-16 lg:grid-cols-12 lg:px-10 lg:py-20">
        <div className="lg:col-span-6">
          <p className="font-serif text-3xl leading-tight">
            Sculpteur <em className="text-terracotta">français</em>
          </p>
          <p className="mt-5 max-w-md text-sm font-light leading-relaxed text-paper/60">
            Une ressource éditoriale indépendante consacrée à la sculpture
            contemporaine en France : définitions, courants, matériaux et repères
            pour celles et ceux qui découvrent cet univers. Aucune œuvre n'est
            vendue sur ce site.
          </p>
          <p className="mt-6 max-w-md text-sm font-light leading-relaxed">
            <Link
              to="/devenez-partenaire-metiers-d-art"
              data-testid="footer-annuaire-gratuit"
              className="link-underline text-paper/85 hover:text-terracotta"
            >
              L'annuaire des métiers d'art, gratuit et ouvert à tous les artisans et ateliers d'art
            </Link>
          </p>
        </div>

        {COLS.map((col) => (
          <div key={col.title} className="lg:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-terracotta">
              {col.title}
            </p>
            <ul className="mt-5 space-y-3">
              {col.links.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").slice(0, 30)}`}
                    className="link-underline text-sm font-light text-paper/70 hover:text-paper"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-paper/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-6 font-mono text-[11px] uppercase tracking-[0.18em] text-paper/40 sm:flex-row sm:items-center sm:justify-between lg:px-10">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} sculpteur-francais.com</span>
          <span className="flex items-center gap-6">
            <Link to="/credits-photos" data-testid="footer-link-credits-photos" className="link-underline hover:text-paper/70">
              Crédits photos
            </Link>
            <span>Site éditorial — aucune vente en ligne</span>
          </span>
        </div>
      </div>
    </footer>
  );
}
